import styles from "./DataCell.module.scss";
import { DayProps, DisabledDayProps } from "./types";

export const WinDay: React.FC<DayProps> = ({ children, isToday, onClick }) => (
  <div className={isToday ? styles.winDay + " " + styles.today : styles.winDay} onClick={onClick}>
    {children}
  </div>
);

export const Day: React.FC<DayProps> = ({ children, isToday, onClick }) => (
  <div className={isToday ? styles.day + " " + styles.selected : styles.day} onClick={onClick}>
    {children}
  </div>
);

export const DisabledDay: React.FC<DisabledDayProps> = ({ day }) => <div className={styles.disabledDay}>{day}</div>;
